import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CouponRedeemResult } from '../../services/ISOTService';
import { SOTService } from '../../services';
import { Subscription } from 'rxjs';

@Component({
  selector: "sot-coupon",
  templateUrl: "./coupon.component.html",
  styleUrls: ["./coupon.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CouponComponent implements OnInit, OnDestroy {

  private _scanCouponSubscription: Subscription;
  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _sotService: SOTService) {
  }
  public isModeOne: boolean = false;
  public isModeTwo: boolean = false;
  public ngOnInit(): void {
    const me = this;
    me._scanCouponSubscription = me._sotService.evScanCouponDone.subscribe(async (couponCode) => {
      // scanned code: no loader, the guest stays on the scan page like with the other scans
      const state = await me._sotService.openCouponProduct(couponCode, false);
      if (state === CouponRedeemResult.Interrupted) {
        // wait for the POS interrupted (reset or guest left the scan page) — nothing left to do
        return;
      }
      if (state === CouponRedeemResult.Done) {
        me.navigateBack();
      } else if (state === CouponRedeemResult.Cancelled) {
        // user backed out of the product screen — return to coupon scan quietly
        me._sotService.SOTConnectionSendScanCoupon();
      } else if (state === CouponRedeemResult.CodeNotValid) {
        me._sotService.OpenCouponCouldNotBeReadDialog((retry) => {
          me.retry(retry);
        });
      } else if (state === CouponRedeemResult.ProductNotAvailable) {
        me._sotService.openCouponArticleNotAvailable((retry) => {
          me.retry(retry);
        });
      } else if (state === CouponRedeemResult.AlreadyInCart) {
        me._handleAlreadyInCart();
      } else {
        me.navigateBack();
      }
    });
    me.isModeOne = me._sotService.useModeOne();
    me.isModeTwo = me._sotService.useModeTwo();
    me._sotService.SOTConnectionSendScanCoupon();
  }

  public retry(res: boolean) {
    const me = this;
    if (res) {
      me._sotService.SOTConnectionSendScanCoupon();
    } else {
      me.navigateBack();
    }
  }

  public ngOnDestroy(): void {
    const me = this;
    me._scanCouponSubscription.unsubscribe();
  }

  public back(): void {
    const me = this;
    me._sotService.SOTConnectionSendCancelScanning();
    me.navigateBack();
  }

  private navigateBack(): void {
    const me = this;
    me._sotService.GoToMenu(null);
  }

  public openManualCouponInput(): void {
    const me = this;
    me._sotService.SOTConnectionSendCancelScanning();
    me._RetryAddManualCoupon();
  }

  /** Opens the "already in cart" dialog; re-arms the scanner on dismiss so the user can scan again. */
  private _handleAlreadyInCart(): void {
    const me = this;
    me._sotService.openCouponInCartDialog((goToBasket) => {
      if (goToBasket) {
        me._sotService.GoToCheckout();
      } else {
        me._sotService.SOTConnectionSendScanCoupon();
      }
    });
  }

  /** hält den Anwender in einer Schleife zum manuellen Eingeben von einem Coupon Code, bis er diese eingabe abbricht */
  private async _RetryAddManualCoupon(): Promise<void> {
    const me = this;
    const couponCode = await me._sotService.OpenManualCouponInput();
    if (couponCode !== "cancel") {
      if (couponCode) {
        const state = await me._sotService.openCouponProduct(couponCode);
        if (state === CouponRedeemResult.Interrupted) {
          // SOT was reset while waiting for the POS — nothing left to do
          return;
        }
        if (state === CouponRedeemResult.Done) {
          me._sotService.GoToMenu(null);
        } else if (state === CouponRedeemResult.Cancelled) {
          // user backed out of the product screen — return to manual input loop
          me._RetryAddManualCoupon();
        } else if (state === CouponRedeemResult.CodeNotValid) {
          me._sotService.OpenCouponCouldNotBeReadDialog(async (retry) => {
            if (retry) {
              me._RetryAddManualCoupon();
            } else {
              me._sotService.SOTConnectionSendScanCoupon();
            }
          });
        } else if (state === CouponRedeemResult.ProductNotAvailable) {
          me._sotService.openCouponArticleNotAvailable(async (retry) => {
            if (retry) {
              me._RetryAddManualCoupon();
            } else {
              me._sotService.SOTConnectionSendScanCoupon();
            }
          });
        } else if (state === CouponRedeemResult.AlreadyInCart) {
          me._sotService.openCouponInCartDialog((goToBasket) => {
            if (goToBasket) {
              me._sotService.GoToCheckout();
        } else {
              me._RetryAddManualCoupon();
            }
          });
        } else {
          me._sotService.SOTConnectionSendScanCoupon();
        }
      } else {
        me._sotService.SOTConnectionSendScanCoupon();
      }
    } // else ignore, abgebrochen durch anwendung
  }
}
